import { render, staticRenderFns } from "./AgreementPackageHarnessPage.vue?vue&type=template&id=5a1abfdf&scoped=true&"
import script from "./AgreementPackageHarnessPage.vue?vue&type=script&lang=js&"
export * from "./AgreementPackageHarnessPage.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPackageHarnessPage.vue?vue&type=style&index=0&id=5a1abfdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1abfdf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1abfdf')) {
      api.createRecord('5a1abfdf', component.options)
    } else {
      api.reload('5a1abfdf', component.options)
    }
    module.hot.accept("./AgreementPackageHarnessPage.vue?vue&type=template&id=5a1abfdf&scoped=true&", function () {
      api.rerender('5a1abfdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dev/AgreementPackageHarnessPage.vue"
export default component.exports